<template>
  <div class="config-label">
    <textInput
      placeholder="Client Label"
      label="Client Label"
      :value="value"
      @change="[setConfigValue($event)]"
      :rules="[(value) => !!value || 'Client label is required.']"
    />
  </div>
</template>
    
<script>
/**
 * @fileoverview Custom input field for config label
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import textInput from "@/qux-common/qux22/components/molecules/input";

export default {
  name: "ConfigLabelField",
  components: { textInput },
  props: {
    category: {
      type: String,
    },
    id: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
  },
  methods: {
    /**
     * Sets the value
     */
    setConfigValue(value) {
      this.$store.dispatch("setConfigValue", {
        ClientInfoRuleId: this.id,
        category: this.category,
        fieldId: "ConfigLabel",
        value: value.trim(),
      });
    },
  },
};
</script>
    
<style lang="scss" scoped>
.config-label {
  margin-bottom: 24px;
}
</style>